import apiSlice from "./apiSlice";
const pmPackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPM: builder.query({
      query: (req) => ({
        url: `p-and-m`,
        params: req,
      })
    }),
    getPMPackages: builder.query({
      query: ({ projectId, type }) => {
        const params = new URLSearchParams();
        if (projectId) params.append("projectId", projectId);
        if (type) params.append("type", type);
        return `WBS?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetPMPackagesQuery,
  useLazyGetPMPackagesQuery,
  useGetAllPMQuery,
} = pmPackagesSlice;
